export const OFFERING_AVAILABILITY_STATUS = {
  active: 1,
  paused: 2,
};
